var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["pickup-store-card", { active: _vm.hasInfo }] },
    [
      _c("vue-client-only", [
        _c(
          "div",
          {
            staticClass: "pickup-store-card__head",
            on: {
              click: function($event) {
                return _vm.$emit("back")
              }
            }
          },
          [
            _c("f-sprite-icon", {
              attrs: { "icon-link": _vm.$options.icons.IconArrow.id }
            }),
            !_vm.adaptive.isDesktop
              ? [_vm._v("\n        Все пункты самовывоза\n      ")]
              : [_vm._v("\n        Назад\n      ")],
            !_vm.adaptive.isDesktop
              ? _c(
                  "div",
                  {
                    staticClass: "close-button",
                    on: {
                      click: function($event) {
                        return _vm.$emit("close")
                      }
                    }
                  },
                  [
                    _c("f-sprite-icon", {
                      attrs: { "icon-link": _vm.$options.icons.IconClose.id }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          2
        )
      ]),
      _c("div", { staticClass: "pickup-store-card__body" }, [
        _c(
          "div",
          { staticClass: "pickup-store-card__info" },
          [
            _vm.hasInfo
              ? _c("checkout-delivery-widget", {
                  staticClass: "pickup-store-card__delivery-widget",
                  attrs: { place: _vm.WIDGET_PLACES.storeCard }
                })
              : _vm._e(),
            _vm.store.type === "store"
              ? [
                  _c(
                    "div",
                    { staticClass: "pickup-store-card__info-store-title" },
                    [
                      _c(
                        "div",
                        { staticClass: "pickup-store-card__info-store" },
                        [
                          _c(
                            "vue-client-only",
                            [
                              !_vm.adaptive.isMobile
                                ? [
                                    _vm._v(
                                      "\n                Магазин\n              "
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _c("f-sprite-icon", {
                            attrs: {
                              "icon-link": _vm.$options.icons.IconLogo.id
                            }
                          })
                        ],
                        1
                      ),
                      _c("products-count-tag", {
                        attrs: {
                          count: _vm.store.availableLinesCount,
                          total: _vm.ids.length
                        }
                      })
                    ],
                    1
                  )
                ]
              : [
                  _c(
                    "div",
                    { staticClass: "pickup-store-card__info-alt-title" },
                    [
                      _c(
                        "div",
                        [
                          _vm.store.type === "postamat"
                            ? [
                                _c("f-sprite-icon", {
                                  attrs: {
                                    "icon-link":
                                      _vm.$options.icons.IconTerminal.id
                                  }
                                })
                              ]
                            : [
                                _c("f-sprite-icon", {
                                  attrs: {
                                    "icon-link":
                                      _vm.$options.icons.IconPickup.id
                                  }
                                })
                              ],
                          _c("span", [_vm._v(_vm._s(_vm.store.name))])
                        ],
                        2
                      ),
                      _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.store.availableLinesCount) +
                            " " +
                            _vm._s(
                              _vm._f("decl")(
                                _vm.store.availableLinesCount,
                                "товар",
                                ["", "а", "ов"]
                              )
                            ) +
                            " из " +
                            _vm._s(_vm.ids.length) +
                            "\n          "
                        )
                      ])
                    ]
                  )
                ],
            _vm.hasMetros
              ? _c(
                  "div",
                  { staticClass: "pickup-store-card__info-metro" },
                  _vm._l(_vm.store.metro, function(metro) {
                    return _c("div", { key: metro.id }, [
                      _c("span", {
                        style: { backgroundColor: metro.line.color }
                      }),
                      _vm._v(_vm._s(metro.name) + "\n        ")
                    ])
                  }),
                  0
                )
              : _vm._e(),
            _c("div", { staticClass: "pickup-store-card__info-title" }, [
              _c("span", { staticClass: "pickup-store-card__info-address" }, [
                _vm._v(_vm._s(_vm.store.address))
              ]),
              _vm.distance
                ? _c(
                    "span",
                    { staticClass: "pickup-store-card__info-distance" },
                    [_vm._v(_vm._s(_vm.distance))]
                  )
                : _vm._e()
            ]),
            _vm.store.workTime
              ? [
                  _vm.computedPhone
                    ? _c(
                        "div",
                        { staticClass: "pickup-store-card__info-phone" },
                        [
                          _c("span", [_vm._v("Телефон:")]),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm._f("noBracesPhone")(_vm.store.phone)) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "pickup-store-card__info-schedule" },
                    [
                      _c("span", [_vm._v("Часы работы:")]),
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("parseWorkSchedule")(_vm.store)) +
                          "\n        "
                      )
                    ]
                  )
                ]
              : _vm._e(),
            _vm.store.type !== "store" && _vm.store.drivingDirections
              ? _c("hint-block", {
                  staticClass: "pickup-store-card__info-hint",
                  attrs: {
                    title: "Как добраться",
                    description: _vm.store.drivingDirections,
                    secondary: _vm.store.insideLocation
                  }
                })
              : _vm._e(),
            _vm.checkLabels(_vm.store)
              ? _c(
                  "div",
                  { staticClass: "pickup-store-card__info-labels" },
                  [
                    _vm.store.needPrepay
                      ? _c("tag", {
                          attrs: {
                            title: "100%&nbsp;&nbsp;предоплата",
                            width: "120px",
                            color: "#ffb71b"
                          }
                        })
                      : _vm._e(),
                    _vm.checkQrCodeRequirement(_vm.store)
                      ? _c("tag", {
                          attrs: {
                            title: "Вход по QR",
                            width: "80px",
                            color: "#C1E0E0"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm.isLockdownMode && _vm.onlineOrdersOnly
              ? _c(
                  "ui-notification",
                  {
                    staticClass: "pickup-store-card__info-warning",
                    attrs: { color: "#FFB71B" }
                  },
                  [
                    _vm._v(
                      "\n        Магазин работает в формате выдачи онлайн-заказов\n      "
                    )
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "pickup-store-card__bottom" },
              [
                _c(
                  "div",
                  { staticClass: "pickup-store-card__bottom-markers" },
                  [
                    _vm.hasFitting
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "pickup-store-card__bottom-icon" },
                            [
                              _c("f-sprite-icon", {
                                attrs: {
                                  "icon-link": _vm.$options.icons.IconFitting.id
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v("\n            Возможна примерка\n          ")
                        ])
                      : _vm._e(),
                    _vm.hasCardPay
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "pickup-store-card__bottom-icon" },
                            [
                              _c("f-sprite-icon", {
                                attrs: {
                                  "icon-link": _vm.$options.icons.IconCard.id
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v("\n            Оплата картой\n          ")
                        ])
                      : _vm._e(),
                    _vm.hasRefund
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "pickup-store-card__bottom-icon" },
                            [
                              _c("f-sprite-icon", {
                                attrs: {
                                  "icon-link": _vm.$options.icons.IconReturn.id
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(
                            "\n            Срок возврата 14 дней\n          "
                          )
                        ])
                      : _vm._e()
                  ]
                ),
                _c("ui-button", {
                  staticClass: "pickup-store-card__bottom-button",
                  attrs: { wide: "", text: "Выбрать" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("select")
                    }
                  }
                })
              ],
              1
            )
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "pickup-store-card__products" },
          [
            _c("div", { staticClass: "pickup-store-card__products-title" }, [
              _vm._v("\n        Товары, доступные для самовывоза\n      ")
            ]),
            !_vm.availableProducts.length
              ? _c("ui-loader", {
                  staticClass: "pickup-store-card__products-list-loader",
                  attrs: { size: "60" }
                })
              : _c(
                  "div",
                  { staticClass: "pickup-store-card__products-list" },
                  _vm._l(_vm.availableProducts, function(product, i) {
                    return _c("store-card-product", {
                      key: product.skuId + ":" + i,
                      attrs: { product: product }
                    })
                  }),
                  1
                )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }